<template>
  <div class="navbar-container d-flex content align-items-center" :class="[
    { homolog: homolog, contingencia: contingencia },
    showDailyAlert ? 'daily-alert-navbar' : ''
  ]">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper d-flex align-items-center">
      <dark-Toggler class="dark-toggler" />
      <span class="system-version ml-2" @click="openModal" v-if="versions.code">
        {{ versions.code }}
      </span>
    </div>

    <!-- ALERTA DAILY -->
    <div v-if="showDailyAlert" class="daily-alert-message-custom-central">
      <span class="alert-emoji">⚠️</span>
      <span class="alert-text">
        Daily <b>não preenchida hoje!</b>
      </span>
      <b-button variant="warning" class="alert-btn ml-4" @click="abrirDailyModal">
        Preencher agora
      </b-button>
    </div>


    <!-- Modal Notas de Versão -->
    <b-modal id="modalVersao" title="Notas da Versão" centered>
      <div class="table-responsive">
        <table class="table table-striped text-center">
          <thead>
            <tr>
              <th>Título</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(issue, index) in versions.version_issues" :key="index">
              <td>
                {{ issue.issue.summary }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="closeModal">Fechar</b-button>
      </template>
    </b-modal>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- Bell Icon Button with Dropdown Template -->
      <b-nav-item-dropdown right class="d-flex bell-nav">
        <template #button-content>
          <b-link class="nav-link">
            <feather-icon icon="BellIcon" size="21" class="bell-icon" />
            <span class="notification-badge" v-if="newNotificationCount > 0">
              {{ newNotificationCount }}
            </span>
          </b-link>
        </template>

        <!-- Lista de notificações com scroll -->
        <template #default>
          <div class="dropdown-scroll">
            <b-dropdown-item v-for="notification in notifications" :key="notification.id" @click="read(notification)">
              {{ notification.description }}
            </b-dropdown-item>

            <b-dropdown-item @click="readAll" v-if="notifications.length > 0">
              <b>Ler todas</b>
            </b-dropdown-item>
            <b-dropdown-item v-else disabled>
              <b>Você não possui novas notificações.</b>
            </b-dropdown-item>
          </div>
        </template>
      </b-nav-item-dropdown>

      <!-- Dropdown do usuário -->
      <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">{{ user.name }}</p>
            <span class="user-status">{{ user.company_name }}</span>
          </div>
          <b-avatar size="40" variant="light-primary" badge :src="user.photo" class="badge-minimal"
            badge-variant="success" />
        </template>

        <!-- Links do dropdown do usuário -->
        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <router-link :to="'/profile'">
            <span>Meu Perfil</span>
          </router-link>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <!-- MODAL DA DAILY -->
    <b-modal id="modalDone" title="Daily não preenchida no dia de hoje" centered hide-footer v-model="showDailyModal"
      @hide="onDailyModalHide">
      <div class="row justify-content-center mt-3">
        <div class="col-md-12">
          <label>O que fez ontem?</label>
          <input v-model="daily.yesterday" type="text" class="form-control" />
        </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-md-12">
          <label>O que vai fazer hoje?</label>
          <input v-model="daily.today" type="text" class="form-control" />
        </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-md-12">
          <label>Houve algum impedimento?</label>
          <select class="form-control" v-model="status" :disabled="!!daily.id">
            <option value="">Não</option>
            <option value="1">Sim</option>
          </select>
        </div>
      </div>
      <div class="row justify-content-center mt-3" v-if="status">
        <div class="col-md-12">
          <label for="">Descreva-o por favor</label>
          <input v-model="daily.impediment" id="impedido" class="form-control" type="text" />
        </div>
      </div>
      <div class="modal-footer mt-3">
        <b-button variant="secondary" @click="showDailyModal = false">Fechar</b-button>
        <b-button variant="primary" @click="saveDaily">Salvar</b-button>
      </div>
    </b-modal>
    <!-- FIM MODAL DAILY -->
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BButton,
  BModal,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import Cookies from "js-cookie";
import env from "@/config/env";

export default {
  data() {
    return {
      versions: {
        version_issues: [],
      },
      user: {},
      notifications: [],
      newNotificationCount: 0,
      versionUpdateInterval: null,
      posts: [],
      daily: {},
      status: "",
      showDailyAlert: false,
      showDailyModal: false,

    };
  },
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    BModal,
    DarkToggler,
  },
  computed: {
    hasUnreadNotifications() {
      return this.notifications.some(
        (notification) =>
          !notification.last_seen &&
          notification.user_id !== this.$store.state.user.id
      );
    },
    homolog() {
      return env.mode === "homolog";
    },
    contingencia() {
      return env.mode === "contingencia";
    },
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
  methods: {

    onDailyModalHide() {
      this.daily = {};
      this.status = "";
    },


    saveDaily() {
      let api = this.$store.state.api + "dailies";
      let dailyData = this.daily;

      // Ajuste impedimento antes de enviar
      if (!this.status) {
        dailyData.impediment = "Não";
      } else {
        dailyData.impediment = "Sim, " + (dailyData.impediment || "");
      }

      axios.post(api, dailyData)
        .then(() => {
          this.daily = {};
          this.status = "";
          this.showDailyModal = false;
          this.showDailyAlert = false;
          this.$message('Sucesso', 'Daily preenchida!', 'success');
        })
        .catch(error => {
          this.$message(null, error.response.data, "error");
        });
    },



    abrirDailyModal() {
      this.showDailyModal = true;
    },


    openModal() {
      this.$bvModal.show("modalVersao");
    },
    getDailyDone() {
      const api = this.$store.state.api + "done-dailies";
      const user = this.$store.state.user;

      axios.get(api)
        .then((response) => {
          // Ajuste conforme o tipo de resposta!
          if ((response.data == 1 || response.data.done_dailies == 1) && user.daily == 1) {
            this.showDailyAlert = true;
          } else {
            this.showDailyAlert = false;
          }
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },

    closeModal() {
      this.$bvModal.hide("modalVersao");
    },
    logout() {
      let api = this.$store.state.api + "logout";
      axios
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");
          this.$router.push({ path: "/login" });
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
    async getVersions() {
      const api = this.$store.state.api + "version_env/";
      try {
        const response = await axios.get(api);
        const newVersion = response.data.code;
        const savedVersion = Cookies.get("current_version");
        if (savedVersion && savedVersion !== newVersion) {
          alert(
            "Uma nova versão está disponível. Por favor, atualize o sistema."
          );
        }
        if (savedVersion !== newVersion) {
          this.saveVersionInCookie(newVersion);
        }
        this.versions = response.data;
      } catch (error) {
        this.$message(null, error.response.data, "error");
      }
    },
    saveVersionInCookie(versionCode) {
      Cookies.set("current_version", versionCode, { expires: 7, path: "/" });
    },
    checkVersion() {
      const savedVersion = Cookies.get("current_version");
      if (savedVersion && savedVersion !== this.versions.code) {
        alert(
          "Uma nova versão está disponível. Por favor, atualize o navegador."
        );
      }
    },
    updateVersionCookie() {
      this.getVersions();
    },
    read(notification) {
      const api = this.$store.state.api + "notification/read";
      axios
        .post(api, { id: notification.id })
        .then((response) => {
          notification.is_read = true;
          this.newNotificationCount = this.notifications.filter(
            (n) => !n.is_read
          ).length;
          this.getNotifications();
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    readAll() {
      const api = this.$store.state.api + "notification/readAll";
      axios
        .post(api)
        .then((response) => {
          this.notifications.forEach((notification) => {
            notification.is_read = true;
          });
          this.newNotificationCount = 0;
          this.getNotifications();
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    getNotifications() {
      const api = this.$store.state.api + "notifications_user";
      axios
        .get(api)
        .then((response) => {
          this.notifications = response.data;
          this.newNotificationCount = this.notifications.length;
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.user = this.$store.state.user;
    this.getVersions();
    this.getNotifications();
    this.getDailyDone();

    this.$root.$on('daily-preenchida', () => {
      this.getDailyDone();
      this.showDailyModal = false;
    });


    window.Echo.channel("posts").listen("PostCreated", (e) => {
      const currentUserId = this.$store.state.user.id;
      if (e.post.user_id !== currentUserId) {
        this.notifications.unshift(e.post);
        this.newNotificationCount++;
        this.getNotifications();
      }
    });
    window.Echo.channel("likes").listen("LikeCreated", (e) => {
      const currentUserId = this.$store.state.user.id;
      if (e.like.user_id !== currentUserId) {
        this.notifications.unshift(e.like);
        this.newNotificationCount++;
        this.getNotifications();
      }
    });
    window.Echo.channel("likes_deleted").listen("LikeDeleted", (e) => {
      const currentUserId = this.$store.state.user.id;
      if (e.userId && e.postId && e.userId !== currentUserId) {
        const notificationIndex = this.notifications.findIndex(
          (notification) =>
            notification.post_id === e.postId &&
            notification.user_id === e.userId
        );
        if (notificationIndex !== -1) {
          this.notifications.splice(notificationIndex, 1);
          this.newNotificationCount--;
        }
      }
    });

    this.versionUpdateInterval = setInterval(() => {
      this.updateVersionCookie();
    }, 3600000);
  },
  beforeDestroy() {
    clearInterval(this.versionUpdateInterval);
  },
};
</script>

<style scoped>
.homolog {
  background-color: #ff9800 !important;
  box-shadow: inset 0 0 0 2px #e65100;
}

.contingencia {
  background-color: #d32f2f !important;
  box-shadow: inset 0 0 0 2px #7f0000;
}

.daily-alert-navbar {
  background-color: #e53935 !important;
  color: #fff !important;
  animation: pulse-daily 1.2s infinite;
  border-radius: 7px;
  box-shadow: 0 0 12px 2px #e5393577;
  position: relative;
  min-height: 60px;
}

@keyframes pulse-daily {
  0% {
    box-shadow: 0 0 12px 2px #e5393577;
  }

  50% {
    box-shadow: 0 0 24px 8px #e5393599, 0 0 12px 2px #fff;
  }

  100% {
    box-shadow: 0 0 12px 2px #e5393577;
  }
}

.daily-alert-message-custom-central {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 999;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70vw;
  /* ou 100% se preferir pegar tudo */
  max-width: 720px;
  padding: 0.7em 1.3em;
  background: transparent;
}

.alert-emoji {
  font-size: 2rem;
  margin-right: 12px;
}

.alert-text {
  font-size: 1.22em;
  font-weight: 700;
  text-align: center;
}

.alert-btn {
  font-weight: bold;
  border-radius: 50px !important;
  padding: 0.5em 1.3em;
  font-size: 1em;
  animation: pulse-button 1.2s infinite;
  box-shadow: 0 0 8px #e5393522;
  background: #fffbe7;
  color: #ffffff !important;
  border: 2px solid #ffd24b;
  margin-left: 2.5em;
  transition: all 0.18s;
}

@keyframes pulse-button {
  0% {
    box-shadow: 0 0 12px 2px #e5393577;
  }

  50% {
    box-shadow: 0 0 24px 8px #e5393599, 0 0 12px 2px #fff;
  }

  100% {
    box-shadow: 0 0 12px 2px #e5393577;
  }
}

.alert-btn:hover,
.alert-btn:focus {
  background: #ffe082;
  color: #d46a07 !important;
  border-color: #ffc107;
}

.dropdown-scroll {
  max-height: 350px;
  overflow-y: auto;
}

.dropdown-scroll::-webkit-scrollbar {
  width: 8px;
}

.dropdown-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(100, 100, 100, 0.6);
  border-radius: 10px;
}

.dropdown-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.system-version {
  font-weight: bold;
  margin-left: 10px;
}

.dark-toggler {
  cursor: pointer;
  font-size: 18px;
  margin-right: 15px;
  margin-left: 10px;
  padding-bottom: 3px;
  color: #333;
  display: flex;
  align-items: center;
}

.bell-nav {
  margin-left: auto;
  display: flex;
  align-items: center;
  position: relative;
}

.bell-icon {
  font-size: 21px;
  color: #333;
  position: relative;
}

.notification-badge {
  position: absolute;
  top: 1px;
  right: 8px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 0.2em 0.5em;
  font-size: 0.75em;
  font-weight: bold;
  min-width: 1em;
  text-align: center;
  line-height: 1;
}

.unread-notification::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: blue;
  border-radius: 50%;
  margin-right: 5px;
}

@media (max-width: 768px) {
  .dark-toggler {
    font-size: 16px;
    margin-right: 10px;
  }

  .bell-nav {
    margin-right: 10px;
  }

  .bell-icon {
    font-size: 18px;
  }

  .notification-badge {
    top: 2px;
    right: 10px;
    font-size: 0.75em;
    padding: 0.15em 0.4em;
  }

  .system-version {
    font-size: 14px;
    margin-left: 5px;
  }
}

@media (max-width: 390px) {
  .bell-nav {
    margin-right: 8px;
  }

  .dark-toggler {
    font-size: 14px;
    margin-right: 8px;
  }
}
</style>
